import { render, staticRenderFns } from "./IconPuzzleOutline.vue?vue&type=template&id=98abbc22"
import script from "./IconPuzzleOutline.vue?vue&type=script&lang=js"
export * from "./IconPuzzleOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports